const eventTypesModel = vm => ({
  title: vm.$gettext('Event Types'),
  endpoint: 'event-types',
  allowNew: true,
  shared: true,
  fields: [
    {
      key: 'id',
      sortable: true
    },
    {
      key: 'name',
      label: vm.$gettext('Name'),
      sortable: true,
      editable: true,
      required: true
    }
  ],
  filters: ['id', 'name']
})

export default eventTypesModel
